import { environment } from 'src/environments/environment';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { forkJoin, Subscription } from 'rxjs';
import { IState } from 'src/app/shared/store/root.reducer';
import { User, AuthService } from 'src/app/shared/services/auth.service';
import { IApplicationLink } from 'ops-lib';
import { AppActions } from 'src/app/shared/store/app.reducer';
import { CommonApiService } from 'src/app/shared/services/commons-api.service';
import { IApplicationRoutes } from 'ops-lib';
import { RequestMakerHelpers } from 'src/app/shared/helpers/request-maker.helper';

@Component({
  selector: 'app-app-navigation',
  templateUrl: './app-navigation.component.html',
  styleUrls: ['./app-navigation.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppNavigationComponent implements OnInit, OnDestroy {
  currentUser: User;
  navigationLinks = <Array<IApplicationLink>>{};
  appId: number;
  subscriptions: Subscription[] = [];

  constructor(
    private router: Router,
    private commonsApiService: CommonApiService,
    private authService: AuthService,
    private store: Store<IState>,
    private requestMakerHelpers: RequestMakerHelpers) { }

  ngOnDestroy() {
    this.subscriptions.map(subscription => {
      subscription.unsubscribe();
    });
  }

  ngOnInit() {
    this.subscriptions.push(this.store.pipe(select(store => store.currentUser)).subscribe(currentUser => {
      this.currentUser = currentUser;
      if (currentUser && currentUser.id > 0) {
        this.appId = environment.appId;
        this.subscriptions.push(this.store.pipe(select(store => store.app.reloadData)).subscribe(() => {
          if (this.appId && this.currentUser.id > 0) {
            forkJoin([
              this.commonsApiService.getNavigationBarLinks(this.requestMakerHelpers.getIRequestIdEncrypted(this.appId)),
              this.commonsApiService.getApplicationsRoutes()
            ]).subscribe(responses => {
              this.processNavigationBarLinks(responses[0]);
              this.processApplicationsRoutes(responses[1]);
            });
          }
        }));
      }
    }));
  }

  private processNavigationBarLinks(navigationLinks: IApplicationLink[]) {
    this.navigationLinks = navigationLinks;
    this.store.dispatch({
      type: AppActions.SET_NAVIGATION,
      payload: navigationLinks
    });
  }

  private processApplicationsRoutes(routes: IApplicationRoutes[]) {
    this.store.dispatch({
      type: AppActions.SET_EXTERNAL_ROUTES,
      payload: routes
    });
  }

  redirect(navigator: any) {
    if (navigator) {
      const url = String(navigator.link.url);
      const langCode = navigator.link.lang_code;
      if (navigator.link.app_id ===  this.appId) {
        this.router.navigate(['claim-status', 'claims']);
      } else {
        if (langCode === 'dotnet_ng') {
          if (url && url !== '#') {
            this.authService.redirect('app-navigation', null, url)
              .subscribe(res => {
                window.open(res, '_blank');
              });
          }
        } else if (langCode === 'dotnet_js') {
          const jsUrl = url  + this.currentUser.cfid;
          window.open(
            jsUrl,
          '_blank'
          );
        } else if (langCode === 'grails') {
          this.commonsApiService.addRedirectToken({ url : url}).subscribe(data => {
            const grailsUrl = url + 'crossAppAuth/jump?token=' + data.token;
            window.open(
              grailsUrl,
            '_blank'
            );
          });
        }
      }
    }
  }
}
